import Promotions from '../../../../../pages/vip/features/promotions-bottom/index';

export default Promotions;
